(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cs-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  const hideMissingIntroImage = (image) => {
    image.hidden = true;
    if (image.classList.contains('cs-collection-hero')) {
      image.closest('.cs-collection-intro')?.classList.remove('cs-collection-intro--image');
    }
  };
  document.addEventListener('error', (event) => {
    if (event.target instanceof HTMLImageElement && event.target.matches('.cs-collection-intro img')) hideMissingIntroImage(event.target);
  }, true);
  const desktop = window.matchMedia('(min-width: 750px)');
  const initialize = (root = document) => {
    root.querySelectorAll('.cs-collection-intro img').forEach((image) => {
      if (image.complete && image.naturalWidth === 0) hideMissingIntroImage(image);
    });
    root.querySelectorAll('.cs-sidebar-shell').forEach((shell) => {
      if (shell.dataset.csInitialized) return;
      shell.dataset.csInitialized = 'true';
      shell.open = desktop.matches;
    });
  };
  initialize();
  desktop.addEventListener('change', () => {
    document.querySelectorAll('.cs-sidebar-shell').forEach((shell) => { shell.open = desktop.matches; });
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-cs-sort], [data-cs-filter-value]')) return;
    const form = event.target.form;
    if (form) form.requestSubmit();
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('.cs-filter-form')) return;
    const fields = Array.from(form.querySelectorAll('input[type="number"]'));
    fields.forEach((input) => { if (input.value === '') input.disabled = true; });
    const min = fields.find((input) => input.name.endsWith('.gte'));
    const max = fields.find((input) => input.name.endsWith('.lte'));
    if (min && max && min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value)) {
      const lower = max.value;
      max.value = min.value;
      min.value = lower;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',(event)=>{const menus=[...document.querySelectorAll('.cs-menu')];for(const menu of menus){if(!menu.contains(event.target))menu.open=false;}});document.addEventListener('keydown',(event)=>{if(event.key==='Escape'){document.querySelectorAll('.cs-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs-product-detail')) {
  customElements.define('cs-product-detail', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelectorAll('[data-cs-options]').forEach((fieldset) => { fieldset.disabled = false; });
      this.addEventListener('change', (event) => { if (event.target.matches('[data-cs-option]')) this.updateVariant(event.target); });
      this.addEventListener('click', (event) => {
        const detailLink = event.target.closest('[data-cs-open-details]');
        if (detailLink) { const target = this.querySelector(detailLink.getAttribute('href')); if (target) { event.preventDefault(); target.open = true; target.scrollIntoView({ block: 'nearest', behavior: 'auto' }); target.querySelector('summary').focus({ preventScroll: true }); } }
        const thumbnail = event.target.closest('[data-cs-media]');
        if (thumbnail) {
          this.querySelector('[data-cs-color-image-placeholder]')?.setAttribute('hidden', '');
          this.querySelectorAll('.cs-pdp-media').forEach((panel) => { panel.hidden = panel.dataset.mediaId !== thumbnail.dataset.csMedia; panel.querySelectorAll('video').forEach((video) => video.pause()); });
          this.querySelectorAll('[data-cs-media]').forEach((button) => button.setAttribute('aria-pressed', String(button === thumbnail)));
        }
        const zoom = event.target.closest('[data-cs-zoom]');
        if (zoom) {
          const dialog = this.querySelector('.cs-pdp-image-dialog');
          const image = dialog.querySelector('.cs-pdp-zoomed');
          image.src = zoom.dataset.csZoom;
          image.alt = zoom.dataset.alt;
          dialog.showModal();
          const viewport = dialog.querySelector('.cs-pdp-zoom-viewport');
          viewport.scrollTop = 0;
          viewport.scrollLeft = Math.max(0, (viewport.scrollWidth - viewport.clientWidth) / 2);
          dialog.querySelector('[data-cs-close]').focus({ preventScroll: true });
        }
        if (event.target.closest('[data-cs-close]')) this.querySelector('dialog').close();
        const quantityButton = event.target.closest('[data-cs-quantity]');
        if (quantityButton) { const input = this.querySelector('[name="quantity"]'); if (quantityButton.dataset.csQuantity === 'plus') input.stepUp(); else input.stepDown(); input.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      this.addEventListener('submit', (event) => { if (this.loading || !this.querySelector('[name="id"]')?.value || this.querySelector('[data-cs-add]')?.disabled) event.preventDefault(); });
    }
    disconnectedCallback() { this.controller?.abort(); }
    async updateVariant(input) {
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      const selected = Array.from(this.querySelectorAll('[data-cs-option]:checked'), (option) => option.value);
      const url = new URL(input.dataset.productUrl || this.dataset.productUrl, location.origin);
      const currentURL = new URL(location.href);
      if (currentURL.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', currentURL.searchParams.get('preview_theme_id'));
      url.searchParams.set('section_id', this.dataset.sectionId);
      url.searchParams.set('option_values', selected.join(','));
      const focusId = input.id;
      const oldQuantity = Number(this.querySelector('[name="quantity"]')?.value || 1);
      const error = this.querySelector('.cs-pdp-update-error');
      error.hidden = true;
      this.loading = true;
      this.setAttribute('aria-busy', 'true');
      this.querySelector('[data-cs-add]').disabled = true;
      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Product update failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (controller.signal.aborted) return;
        const nextProduct = html.querySelector('cs-product-detail');
        const next = nextProduct?.querySelector('[data-cs-product-render]');
        if (!next) throw new Error('Product section missing');
        let initializeReviews = false;
        for (const selector of ['[data-cs-yotpo-rating]', '[data-cs-yotpo-reviews]']) {
          const currentWidget = this.querySelector(selector);
          const nextWidget = next.querySelector(selector);
          if (currentWidget && nextWidget && currentWidget.dataset.yotpoProductId === nextWidget.dataset.yotpoProductId) {
            nextWidget.replaceWith(currentWidget);
          } else if (nextWidget) {
            initializeReviews = true;
          }
        }
        this.querySelector('[data-cs-product-render]').replaceWith(next);
        if (initializeReviews && typeof window.yotpoWidgetsContainer?.initWidgets === 'function') {
          window.yotpoWidgetsContainer.initWidgets();
        }
        this.dataset.productUrl = nextProduct.dataset.productUrl;
        this.querySelectorAll('[data-cs-options]').forEach((fieldset) => { fieldset.disabled = false; });
        const quantity = this.querySelector('[name="quantity"]');
        const min = Number(quantity.min || 1), step = Number(quantity.step || 1), max = quantity.max ? Number(quantity.max) : Infinity;
        quantity.value = String(Math.max(min, Math.min(max, min + Math.floor(Math.max(0, oldQuantity - min) / step) * step)));
        const nextURL = new URL(this.dataset.productUrl, location.origin);
        if (currentURL.searchParams.has('preview_theme_id')) nextURL.searchParams.set('preview_theme_id', currentURL.searchParams.get('preview_theme_id'));
        if (next.dataset.variantId) nextURL.searchParams.set('variant', next.dataset.variantId);
        else nextURL.searchParams.set('option_values', selected.join(','));
        if (!window.Shopify?.designMode) history.replaceState({}, '', nextURL);
        const focus = this.querySelector('[id="' + CSS.escape(focusId) + '"]');
        focus?.focus({ preventScroll: true });
      } catch (failure) {
        if (failure.name === 'AbortError') return;
        error.replaceChildren(document.createTextNode(this.dataset.error + ' '));
        const retry = document.createElement('a');
        const destination = new URL(url); destination.searchParams.delete('section_id');
        retry.href = destination; retry.textContent = this.dataset.errorLink || '↗';
        error.append(retry); error.hidden = false;
      } finally {
        if (this.controller === controller) { this.loading = false; this.removeAttribute('aria-busy'); }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-recommendations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs-recommendations')) {
  customElements.define('cs-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-auto') || this.loaded) return;
      this.loaded = true;
      this.load();
    }
    async load() {
      try {
        const url = new URL(this.dataset.url, location.origin);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url);
        if (!response.ok || !this.isConnected) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('[data-cs-recommendations-content]');
        if (!content?.querySelector('.cs-product')) return;
        this.querySelector('[data-cs-recommendations-content]').replaceWith(content);
        this.hidden = false;
      } catch (_) { /* Keep the existing editor preview or hide empty recommendations. */ }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
